import { ASSET_BASE_URL } from './config'

export function resolveUrl(url) {
  if (!url) return ''
  if (/^https?:\/\//.test(url)) return url
  return ASSET_BASE_URL + (url.startsWith('/') ? url : '/' + url)
}

export function parseExpertise(expertise) {
  if (!expertise) return []
  if (Array.isArray(expertise)) return expertise
  return String(expertise)
    .split(/[,，、]/)
    .map(s => s.trim())
    .filter(Boolean)
}

export function maskPhone(phone) {
  if (!phone) return ''
  const s = String(phone).replace(/\D/g, '')
  if (s.length >= 11) {
    return s.slice(0, 3) + '****' + s.slice(-4)
  }
  if (s.length >= 7) {
    return s.slice(0, 3) + '****' + s.slice(-2)
  }
  return phone
}

export function extractUploadPath(result) {
  if (!result) return ''
  const url = typeof result === 'string' ? result : result.url || result.fullurl || result.path || ''
  if (!url) return ''
  if (url.startsWith('/')) return url
  if (url.startsWith(ASSET_BASE_URL)) return url.replace(ASSET_BASE_URL, '')
  const match = url.match(/\/uploads\/.+/)
  return match ? match[0] : url
}

const MODULE_ROUTE_MAP = {
  expert: '/experts',
  research: '/cooperation',
  recycle: '/recycling'
}

export function getModuleRoute(item) {
  if (!item) return ''
  if (item.mini_app_link) return item.mini_app_link
  const path = item.mini_app_path || ''
  for (const key of Object.keys(MODULE_ROUTE_MAP)) {
    if (path.includes(key)) return MODULE_ROUTE_MAP[key]
  }
  return ''
}

export const MODULE_COLORS = ['#7c4dff', '#00c853', '#ff9100', '#651fff', '#0091ea', '#d50000']
